// ===========================================
// File Visibility Chip Component
// ===========================================

import { Chip } from '@mui/material';
import {
  Lock as LockIcon,
  Person as PersonIcon,
  Visibility as VisibilityIcon,
} from '@mui/icons-material';
import { FileVisibility } from '../../../api/resources.api';
import { getFileVisibilityLabel, getFileVisibilityColor } from './students.helpers';

interface Props {
  visibility: FileVisibility;
}

/**
 * Visibility chip showing who can see the file
 */
export default function FileVisibilityChip({ visibility }: Props) {
  const getIcon = () => {
    switch (visibility) {
      case 'TEACHERS_ONLY':
        return <LockIcon sx={{ fontSize: 14 }} />;
      case 'TEACHERS_AND_PARENTS':
        return <PersonIcon sx={{ fontSize: 14 }} />;
      case 'ALL':
        return <VisibilityIcon sx={{ fontSize: 14 }} />;
      default:
        return <VisibilityIcon sx={{ fontSize: 14 }} />;
    }
  };

  return (
    <Chip
      icon={getIcon()}
      label={getFileVisibilityLabel(visibility)}
      size="small"
      color={getFileVisibilityColor(visibility)}
      sx={{ height: 22, '& .MuiChip-label': { px: 1 } }}
    />
  );
}
